/**
 * Created by Jim on 2018/5/14.
 * Modify by handd on 2018/5/15.
 * Upgrade antd 4 on 2022/9/8.
 */
import axios from "axios";

//const
export const EQUIPMENT_CERTIFY_DESTROY_UPDATE_DATA = "equipmentCertifyDestroy/EQUIPMENT_CERTIFY_DESTROY_UPDATE_DATA";
export const EQUIPMENT_CERTIFY_DESTROY_STORE_EQUIPMENT_CERTIFY = "equipmentCertifyDestroy/EQUIPMENT_CERTIFY_DESTROY_STORE_EQUIPMENT_CERTIFY";
export const EQUIPMENT_CERTIFY_DESTROY_TOGGLE_MODAL = "equipmentCertifyDestroy/EQUIPMENT_CERTIFY_DESTROY_TOGGLE_MODAL";
export const EQUIPMENT_CERTIFY_DESTROY_TOGGLE_LOADING = "equipmentCertifyDestroy/EQUIPMENT_CERTIFY_DESTROY_TOGGLE_LOADING";

export const EQUIPMENT_CERTIFY_DESTROY_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_success_title";
export const EQUIPMENT_CERTIFY_DESTROY_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitSuccess_content";
export const EQUIPMENT_CERTIFY_DESTROY_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_fail_title";
export const EQUIPMENT_CERTIFY_DESTROY_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_submitFail_content";
export const EQUIPMENT_CERTIFY_DESTROY_MODAL_OK_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_OK_label";
export const EQUIPMENT_CERTIFY_DESTROY_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyDestroy_modal_cancel_label";

//reducer
export const equipmentCertifyDestroy = (state = {
  loading: false,
  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,
  id: "",
  description: "",
  destroyDescription: "",
}, action) => {
  switch (action.type) {
    case EQUIPMENT_CERTIFY_DESTROY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CERTIFY_DESTROY_STORE_EQUIPMENT_CERTIFY:
      return {
        ...state,
        id: action.data.id,
        description: action.data.description,
        destroyDescription: "",
      };
    case EQUIPMENT_CERTIFY_DESTROY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_CERTIFY_DESTROY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentCertifyDestroyData = (data) => {
  return {
    type: EQUIPMENT_CERTIFY_DESTROY_UPDATE_DATA,
    data: data
  }
};

/**
 * get all equipment certify destroy
 */
export const initEquipmentCertifyDestroy = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentCertifyById/${data.id}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        response.data.id = data.id;
        dispatch(storeEquipmentCertifyDestroy(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store equipment certify destroy
 */
export const storeEquipmentCertifyDestroy = (equipmentCertify) => {
  return {
    type: EQUIPMENT_CERTIFY_DESTROY_STORE_EQUIPMENT_CERTIFY,
    data: equipmentCertify
  }
};


/**
 * submit equipment certify destroy
 * @deprecated since 20220909
 */
export const submitEquipmentCertifyDestroy = (data) => {
  return (dispatch) => {
    dispatch(toggleLoading(true));
    axios({
      method: "PUT",
      url: "/api-equipment/destroyEquipmentCertify",
      contentType: "application/json",
      withCredentials: true,
      data: {
        "id": data.id,
        "destroyUserId": data.releaseUserId,
        "destroyUserName": data.releaseUserName,
        "destroyDescription": data.destroyDescription,
      },
    }).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.status === 200) {
          console.info("success submit equipment certify destroy");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_CERTIFY_DESTROY_MODAL_SUCCESS_TITLE,
            modalContent: EQUIPMENT_CERTIFY_DESTROY_MODAL_SUBMIT_SUCCESS_CONTENT,
            modalOk: EQUIPMENT_CERTIFY_DESTROY_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_CERTIFY_DESTROY_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({
                modalVisible: false
              }));
              this.props.history.goBack();
            },
            onCancel: () => {
              dispatch(toggleModal({
                modalVisible: false
              }));
              this.props.history.goBack();
            }
          }));
        } else {
          console.error("fail to submit equipment certify destroy");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_CERTIFY_DESTROY_MODAL_FAIL_TITLE,
            modalContent: EQUIPMENT_CERTIFY_DESTROY_MODAL_SUBMIT_FAIL_CONTENT,
            modalOk: EQUIPMENT_CERTIFY_DESTROY_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_CERTIFY_DESTROY_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
            }
          }));
        }
      }
    );
  };
};


/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_DESTROY_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_DESTROY_TOGGLE_LOADING,
    data: show
  }
};
